module.exports = __webpack_public_path__ + "media/images/lb/963-f1337a1e56f78715aa0ae69018e2b57b.svg";